import { Flex, Heading } from '@chakra-ui/react';

import { NavigationButtons } from '~/components/navigation/NavigationButtons';

interface PageHeaderProps {
  title: string;
  onBack: () => void;
  onContinue: () => void;
  backLabel?: string;
  continueLabel?: string;
}

export const PageHeader = ({
  title,
  onBack,
  onContinue,
  backLabel,
  continueLabel,
}: PageHeaderProps) => {
  return (
    <Flex justify="space-between" align="center" p={6}>
      <Heading size="xl">{title}</Heading>
      <NavigationButtons
        onBack={onBack}
        onContinue={onContinue}
        backLabel={backLabel}
        continueLabel={continueLabel}
      />
    </Flex>
  );
};
